import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';

import { BracketedWrapper } from '@sorare/core/src/atoms/BracketedWrapper/index.tsx';
import { BrandL, BrandXL } from '@sorare/core/src/atoms/typography/index.tsx';
import type { HexColor } from '@sorare/core/src/style/types.ts';

type Props = { score: number; color: HexColor };
export const BracketedScore = ({ score, color }: Props) => {
  return (
    <BracketedWrapper style={{ '--border-color': color } as CSSProperties}>
      <BrandL color={color}>
        <FormattedMessage
          defaultMessage="<span>{score, number, ::. rounding-mode-down}</span>pts"
          values={{
            score,
            span: chunks => <BrandXL as="span">{chunks}</BrandXL>,
          }}
        />
      </BrandL>
    </BracketedWrapper>
  );
};
